<template>
    <div class="container-admin-or-collaborator-delete">
        <p>Selecione um <strong>{{typeGroup(user.group)}}</strong> para receber os dados do usuário(a) <strong>{{user.name}}</strong> </p>
        <p>O usuário selecionado passará a fazer parte das filas de distribuição de leads e oferta ativa, caso o usuário(a) <strong>{{user.name}}</strong> faça parte de alguma dessas filas.</p>
        <ui-select-v2
			v-model="selectNewUser"
			:data="users"
			:label="typeGroup(user.group) + ':'"
            :loading="loader"
			size="md"
			item-label="first_name"
			return-label="id"
			:search-event="user.group"
			ajax-search
            @input='leave'
		/>
    </div>
</template>


<script>
import { uiSelectV2 } from '@/components/ui/form'
import { user } from '@/services/axios'
import { alertMixin } from '@/mixins'

import axios from 'axios'

export default {
    name: 'ui-admin-or-collaborator',
    components: {
        uiSelectV2
    },
    props: {
        user: {
            type: [String, Object],
            default: () => {}
        }
    },

    mixin: [alertMixin],

    data() {
        return {
            users: [],
            pagination: {
				page: 1,
				total_pages: 1
			},
            selectNewUser: null,
			admins: [],
            loader: false
        }
    },

    async mounted() {
        if (['admin', 'collaborator'].includes(this.user.group)) {
			await this.loadUsers(this.user.group, '', this.pagination.page)
		}

        this.$root.$on(`select2-ajax-search-${this.user.group}`, async (data) => {
		
            if (!data.nextPage) {
                this.$set(this.pagination, 'page', 1)
                this.$set(this.pagination, 'total_pages', 1)
                this.selectNewUser = null
                this.admins = []

            } else {
                if (this.pagination.page < this.pagination.total_pages) {
                    this.$set(this.pagination, 'page', this.pagination.page + 1)

                } else {
                    return
                }
            }

            if (this.cancelToken) this.cancelToken.cancel()
            this.cancelToken = axios.CancelToken.source()
            await this.loadUsers(
                this.user.group,
                data.search,
                this.pagination.page
            )
        })
    },
    
    methods: {
        //traz o tipo do grupo com o nome inteiro e em português
        typeGroup(group) {
            var groupUser = ''
            switch (group) {
                case 'admin':
                groupUser = 'Administrador'
                    break
                case 'collaborator':
                groupUser = 'Colaborador'
                break
            }
            return groupUser
        },

        // Faz a chamada que carrega os usuários
        async loadUsers(group, search, page) {
            
            this.users = []
            if (!group) return

            this.loader = true
            try {
                const params = {
		            group,
		            q: search,
		            page,
		            perPage: 15,
                }
                const { data } = await user.getAll('search', params)

                if (data.data.status === 'error') throw data.data.msg

                this.users = data.data.filter(item => { if (this.user.id !== item.id) return item })

            } catch (error) {
                this.$mx_alertError(error)
            } finally {
                this.loader = false
            }
        },

        //manda informação para deletar o usuário
        leave(user) {
            if(user.length == 0) {
                return this.$emit('desactive', 'remove', true)
            };
            this.$emit('desactive', 'remove', false)
            this.$emit('input', user.id, null, null)
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>